export default __webpack_public_path__ + "static/media/unity-ui.acf45b7c.jpg";